import { useRef } from 'react';
import Slider from 'react-slick';
import { BreakpointSetting, CarouselProps, CarouselSettings } from './Carousel.types';
import { CarouselButton, CarouselItem } from './Carousel.styles';
import { CarouselFeed } from './CarouselFeed.component';
import { useTheme } from 'styled-components';



//TODO: Fix currentSlide/slideCount issue possible by replacing with custom buttons and state management instead of react-slick's internal state management which is out of sync with the custom buttons when using responsive settings that change slidesToShow and slidesToScroll values. This is causing incorrect disabling of buttons when at the beginning or end of the carousel.
export function Carousel<T extends Record<string, any>>({
  RenderComponent,
  CarouselItems,
  slidesToShow,
  slidesToScroll,
  loop = false,
  animate = false,
  fadeAnimation = false,
  accessibleButtons = false,
  showArrows = false,
  showDotPaging = false,
  initialSlide = 0,
  settingsLG,
  settingsMD,
  settingsSM,
  CarouselItemClasses = '',
}: CarouselProps<T>) {

  const sliderRef = useRef<Slider | null>(null);
  const { Grid } = useTheme();

  const sliderSettings: CarouselSettings = {
    ref: sliderRef as React.RefObject<Slider>,
    accessibility: accessibleButtons,
    arrows: showArrows,
    autoplay: animate,
    dots: showDotPaging,
    infinite: loop,
    initialSlide,
    slidesToShow,
    slidesToScroll,
    fade: false,
    responsive: [] as BreakpointSetting[],
    nextArrow: <CarouselButton />,
    prevArrow: <CarouselButton />
  };

  if (fadeAnimation) {
    sliderSettings.slidesToShow = 1;
    sliderSettings.slidesToScroll = 1;
    sliderSettings.fade = true;
  } else {
    if (settingsLG) {
      sliderSettings.responsive.push({
        breakpoint: Grid.Breakpoints.LG,
        settings: settingsLG,
      })
    }

    if (settingsMD) {
      sliderSettings.responsive.push({
        breakpoint: Grid.Breakpoints.MD,
        settings: settingsMD,
      })
    }

    if (settingsSM) {
      sliderSettings.responsive.push({
        breakpoint: Grid.Breakpoints.SM,
        settings: settingsSM,
      })
    }
  }




  let appId = process.env.REACT_APP_CLIENTID;
  // Temporary fix for Zebra's unique carousel implementation which doesn't work with react-slick, likely due to the complex layout and styling requirements. This will be replaced with a custom-built carousel component in the future to allow for more flexibility and control over the functionality and styling.
  if (["zebratechnologies", "ricoh-rewards"].includes(appId as string)) {
    return <>

      {/* <code><pre>{JSON.stringify(CarouselItems, null, 4)}</pre></code> */}
      <CarouselFeed items={CarouselItems} />


      {/* {CarouselItems.map((item, index) => (
        <CarouselItem key={index} className={CarouselItemClasses ? CarouselItemClasses : undefined}>
          <RenderComponent {...item} />
        </CarouselItem>
      ))} */}
    </>
  }



  return (
    <div className="pos-relative">
      <Slider {...sliderSettings}>
        {CarouselItems.map((item, index) => (
          <CarouselItem key={index} className={CarouselItemClasses ? CarouselItemClasses : undefined}>
            <RenderComponent {...item} />
          </CarouselItem>
        ))}
      </Slider>
    </div>
  );
}